const u = (t) => t != null && (typeof t == "string" || typeof t == "number"), l = (t) => t !== null && typeof t == "object" && !Array.isArray(t), f = (t) => Object.keys(t);
function p(t, ...e) {
  return e.length ? e.reduce((o, n) => {
    const { [n]: s, ...c } = o;
    return c;
  }, t) : t;
}
function O(t, e, r) {
  if (!t) return r;
  const n = (typeof e == "string" ? e.split(".") : e).reduce((s, c) => s && s[c] !== void 0 ? s[c] : void 0, t);
  return n !== void 0 ? n : r;
}
function i(t, e, r) {
  return f({ ...t, ...e }).reduce((o, n) => ((r ? r(t[n]) === r(e[n]) : t[n] === e[n]) || (o[n] = e[n]), o), {});
}
const g = (t, e) => Object.entries(i(t, e)).length === 0, y = (t, e) => {
  if (typeof t != "object" || typeof e != "object" || t === null || e === null)
    return t === e;
  const r = Object.keys(t), o = Object.keys(e);
  if (r.length !== o.length) return !1;
  for (const n of r)
    if (!Object.prototype.hasOwnProperty.call(e, n) || t[n] !== e[n])
      return !1;
  return !0;
}, m = (t, e) => {
  if (!t) return;
  const r = {};
  for (let o = 0; o < t.length; o++) {
    const n = t[o], s = typeof e == "function" ? e(n) : n[e], c = u(s) ? s : String(s);
    r[c] = (r[c] || []).concat(n);
  }
  return r;
}, d = (t, e) => Object.fromEntries(
  Object.entries(t).map(([r, o]) => [r, e(o, r)])
);
export {
  g as areDeepEqual,
  i as diff,
  O as get,
  m as groupBy,
  l as isObject,
  u as isValidKey,
  f as keysOf,
  d as mapObject,
  p as omit,
  y as shallowCompare
};
